<template>
  <v-container class="fill-height" fluid style="min-height: 434px">
    <v-row>
      <v-col
        v-for="(item, index) in galleryItems"
        :key="index"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card>
          <v-img :src="item.src" height="200" class="grey darken-4"></v-img>
          <v-card-title class="text-h6">{{ item.title }}</v-card-title>
          <v-expand-transition>
            <v-card-text v-if="item.expanded">
              {{ item.description }}
            </v-card-text>
          </v-expand-transition>
          <v-card-actions>
            <v-icon @click="toggleDescription(item)">
              {{ item.expanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      galleryItems: [
  {
    src: "https://www.desatascoshenares.com/wp-content/uploads/2021/04/fugas-agua-hogar-1080x675.jpg",
    title: "Reparación de fugas y tuberías defectuosas",
    description: "Solucionamos problemas de fugas y daños en las tuberías de manera rápida y eficiente. Nuestro equipo experto identifica y repara cualquier fuga, asegurando un sistema de fontanería en óptimas condiciones.",
    expanded: false,
  },
  {
    src: "https://blog.groupsumi.com/wp-content/uploads/2023/02/termo-electrico-de-diseno-para-instalacion-en-bano.jpg",
    title: "Instalación de sistemas de agua caliente",
    description: "Implementamos sistemas de agua caliente para cocinas, baños y otras áreas, garantizando un suministro constante y eficiente. Ya sea a través de calentadores de agua tradicionales o sistemas de agua caliente instantánea, nos adaptamos a sus necesidades.",
    expanded: false,
  },
  {
  src: "https://images.squarespace-cdn.com/content/v1/52dfe66be4b0cad36168429a/1578499271218-CQ28O0ZWJ811JO1CAKBC/emmme+studio+reforma+dise%C3%B1o+interiores+ba%C3%B1o+mangueton+bote+sifonico.jpg",
  title: "Instalación de nueva fontanería",
  description: "Transformamos su sistema de fontanería con nuestra experiencia en la instalación de nuevas tuberías y conexiones. Desde la planificación hasta la ejecución, garantizamos un sistema eficiente y moderno. Nuestro equipo experto se encarga de cada detalle, asegurando un rendimiento óptimo y cumplimiento de las normativas para un funcionamiento seguro y duradero.",
  expanded: false,
}

],

    };
  },
  methods: {
    toggleDescription(item) {
      item.expanded = !item.expanded;
    },
  },
};
</script>
